import { ReactElement, useState } from 'react';
import { IComponentMapFields, IPageLocationFields } from 'types/contentful';
import MapWrapper from 'components/UI/Map';
// import MapMarker from 'components/UI/MapMarker';
// import LocationMarkerSvg from 'components/UI/MapMarker/LocationMarkerSvg';
// import InfoCard from 'components/UI/InfoCard';
import RichText from 'components/UI/Richtext';
import type { Entry } from 'contentful';
import CTA from 'components/UI/Cta';
import LinkWithIcon from 'components/UI/LinkWithIcon';
import { LINK_CONTENT_TYPE } from 'lib/consts';
import IFrameCTA from 'components/UI/IFrameCta';

export interface MapComponentProps extends Omit<Omit<IComponentMapFields, 'locations'>, 'id'> {
  /** List of location items */
  nearbyLocations?: Entry<IPageLocationFields>[];
  listLocations?: Entry<IPageLocationFields>[];

  /** Center location co ordinate */
  content?: IPageLocationFields;

  /** Hide Eye Icon */
  hideEyeIcon: boolean;

  /** Marker Pin Icon Type */
  markerIcon?: string;
}

export type Location = IPageLocationFields & {
  currentDistance?: number;
  sysId?: string;
  current?: boolean;
};

export default function Map({
  bannerText,
  content,
  // defaultZoom,
  hideEyeIcon,
  markerIcon = 'Eye-V01',
  nearbyLocations,
  cta,
  heading,
  listLocations,
}: MapComponentProps): ReactElement {
  const mapLocations = [
    ...(nearbyLocations || []).map((location) => {
      return {
        ...location.fields,
        map: location.fields.map,
        name: location.fields.name,
        slug: location.fields.slug,
      };
    }),
  ];

  const listLocationsData = [
    ...(listLocations || []).map((location) => {
      return {
        ...location.fields,
        map: location.fields.map,
        name: location.fields.name,
        slug: location.fields.slug,
      };
    }),
  ];

  const [activeLocation, setActiveLocation] = useState<Location | null>(null);

  const hasHeading = (): boolean => !!(heading || bannerText || cta);

  return (
    <div className="px-site-component py-10 md:py-20 bg-muted">
      <div
        className={`grid gap-8 lg:grid-cols-2 lg:gap-12 xl:gap-16 items-start ${
          hasHeading() ? 'mb-36px' : ''
        }`}
      >
        <div className="bordered-heading-richtext">
          {heading && (
            <RichText
              document={heading}
              classNames="font-heading text-new-34 lg:text-4xl lg:leading-new-43 richtext-font-inherit"
              noEmpty={true}
            />
          )}
        </div>
        <div className="text-left">
          {bannerText && (
            <RichText
              document={bannerText}
              classNames="text-lg text-primary-actual image-text-richtext"
            />
          )}
          {cta && (
            <div className="max-w-none ecp-mb flex justify-start mt-8">
              {cta.sys.contentType.sys.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
                <IFrameCTA {...cta.fields} backgroundColor="black" classNames="w-full md:w-auto" />
              ) : (
                <CTA
                  {...cta.fields}
                  classNames="text-primary-actual button-text bg-white w-full md:w-auto"
                />
              )}
            </div>
          )}
        </div>
      </div>

      {listLocationsData && (
        <ul className="list-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-4 gap-x-6 mb-36px">
          {listLocationsData.map((location, index) => {
            const { name, slug } = location;
            return (
              <li key={index} className="h-full">
                <LinkWithIcon text={name} slug={slug} icon="location" />
              </li>
            );
          })}
        </ul>
      )}

      {nearbyLocations && content && (
        <div style={{ height: '500px' }}>
          <MapWrapper
            // defaultZoom={defaultZoom}
            iconDetails={{
              hideEyeOnPin: hideEyeIcon,
              classNames: 'text-primary-actual',
              markerIcon,
            }}
            activeLocation={activeLocation}
            setActiveLocation={setActiveLocation}
            foundLocations={mapLocations}
            showPopUp={true}
            defaultCenter={{
              lat: content.map.lat,
              lng: content.map.lon,
            }}
            renderInfoCard={'InfoCard'}
          />
          {/* single marker for current location */}
          {/* <MapMarker
              lat={content.map.lat}
              lng={content.map.lon}
              onClick={() => setActiveLocation(activeLocation !== -1 ? -1 : null)}
              showCard={activeLocation === -1}
              renderInfoCard={() => (
                <InfoCard fields={content} slug={content.slug} current={true} />
              )}
              focused={activeLocation === -1}
            >
              <LocationMarkerSvg
                title={content.name}
                hideEyeOnPin={hideEyeIcon}
                classNames="text-primary-actual"
                focused={activeLocation === -1}
                markerIcon={markerIcon}
              />
            </MapMarker> */}
          {/* multiple markers */}
          {/* {nearbyLocations &&
              nearbyLocations.map((location, i) => (
                <MapMarker
                  key={i}
                  lat={location.fields?.map.lat}
                  lng={location.fields?.map.lon}
                  onClick={() => setActiveLocation(i !== activeLocation ? i : null)}
                  showCard={activeLocation === i}
                  renderInfoCard={() => (
                    <InfoCard fields={location.fields} slug={location.fields.slug} />
                  )}
                  focused={activeLocation === i}
                >
                  <LocationMarkerSvg
                    title={location.fields?.name}
                    hideEyeOnPin={hideEyeIcon}
                    classNames="text-tertiary-actual"
                    focused={activeLocation === i}
                    markerIcon={markerIcon}
                  />
                </MapMarker>
              ))} */}
          {/* </MapWrapper> */}
        </div>
      )}
    </div>
  );
}
